import Container from "../container/Container";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <header className="min-h-screen bg-white">
      <Container>
        <div className="flex items-center justify-between py-4 px-2 md:px-2">
          <img src="/images/LogoSec.png" alt="" className="h-10 lg:h-14" />
          <div>
            <Link
              to="/sign-up"
              className="px-7 uppercase py-3 rounded-full font-semibold bg-indigo-600 text-white focus:outline-none hover:bg-indigo-500"
            >
              Sign Up
            </Link>
          </div>
        </div>
        <div className="grid lg:grid-cols-2 lg:items-center lg:gap-5 pt-10 px-3">
          <div className="flex flex-col items-center lg:items-start space-y-5 sm:space-y-10 lg:pt-8">
            <h1 className="text-5xl text-center  font-bold lg:text-left md:text-6xl lg:text-7xl header__fonts">
              The World <span className="text-indigo-600">Developers</span> come
              Together.
            </h1>
            <p className="header__fonts text-2xl lg:w-96  font-bold text-gray-700 text-center lg:text-left">
              One platform for your team and your work
            </p>
            <button className="px-7 uppercase py-3 rounded-full font-semibold bg-indigo-600 text-white focus:outline-none hover:bg-indigo-500">
              Learn More
            </button>
          </div>
          <div className="mt-16 sm:mt-0 grid place-items-end">
            <img src="/images/Header.svg" alt="" className="" />
          </div>
        </div>
      </Container>
    </header>
  );
};

export default Header;
